import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
);

export const BarChart = ({ data, options, style }) => {
  return (
    <div className="bg-foreground shadow-md rounded-lg p-4" style={style}>
      <Bar data={data} options={options} />
    </div>
  );
};
